import React from 'react';
import clsx from 'clsx';
import { IoIosArrowDropdownCircle } from 'react-icons/io';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { useStyles } from './styles';

interface ICustomDropdown {
  open: boolean;
  text: string;
  labels: string[];
  toggle: any;
  onClickItem: any;
  height?: number | string;
  width?: number | string;
}

const CustomDropdownAlt: React.FC<ICustomDropdown> = ({
  open,
  text,
  toggle,
  labels,
  onClickItem,
  height,
  width,
}) => {
  const classes = useStyles();

  return (
    <Dropdown
      direction="down"
      className={classes.container}
      isOpen={open}
      toggle={toggle}
    >
      <DropdownToggle
        className={clsx(classes.toggle, {
          [classes.toggleSelected]: open,
        })}
        tag="span"
        data-toggle="dropdown"
        style={{
          height,
          width,
        }}
      >
        <div className={classes.iconContainer}>
          <IoIosArrowDropdownCircle
            size={30}
            color="#7030A0"
            style={{ marginRight: 8 }}
          />
        </div>
        {text}
      </DropdownToggle>
      <DropdownMenu container="body">
        {labels.map((label, idx) => (
          <DropdownItem
            className={classes.item}
            key={idx}
            onClick={onClickItem}
          >
            {label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CustomDropdownAlt;
